import React from "react";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import GridOnOutlinedIcon from "@material-ui/icons/GridOnOutlined";

export const CsvIcon = () => (
    <div
        style={{
            position: "relative",
            width: 28,
            height: 28,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
    >
        <DescriptionOutlinedIcon
            style={{
                fontSize: 29,
                color: "#607D8B"
            }}
        />

        <span
            style={{
                position: "absolute",
                bottom: 3,
                fontSize: 7,
                fontWeight: 700,
                lineHeight: "10px",
                color: "#607D8B",
                background: "#ECEFF1",
                padding: "0 2px"
            }}
        >
            CSV
        </span>
    </div>
);

export const ExcelIcon = () => (
    <div
        style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
    >
        <GridOnOutlinedIcon
            style={{
                fontSize: 29,
                color: "#43A047"
            }}
        />

        <span
            style={{
                position: "absolute",
                bottom: 3,
                fontSize: 7,
                fontWeight: 700,
                lineHeight: "10px",
                color: "#2E7D32",
                background: "#E8F5E9",
                padding: "0 2px"
            }}
        >
            XLSX
        </span>
    </div>
);